import { CANDIDATE_PROFILE_DRAFT_STORAGE_PREFIXES } from "../candidate-personalization/personalization.constants";

export const TALENT_NETWORK_DRAFT_STORAGE_PREFIX = CANDIDATE_PROFILE_DRAFT_STORAGE_PREFIXES.talent_network;
export const TALENT_NETWORK_PROFILE_ROUTE = "talent-network/profile";
export const TALENT_NETWORK_JOINED_QUERY_PARAM = "talent-network-joined";
export const TALENT_NETWORK_SUMMARY_QUERY_KEY = (username: string) =>
  ["talent-network", "summary", username] as const;
export const TALENT_NETWORK_JOIN_ERROR = "Unable to join the network. Please try again.";
export const TALENT_NETWORK_CHART_PERCENT = 100;
export const TALENT_NETWORK_EMPLOYERS_HIRING_MINIMUM = 10;
export const TALENT_NETWORK_COLLAPSED_FIELD_LIMIT = 10;
export const TALENT_NETWORK_ACTION_CLASS_NAME =
  "h-auto min-h-11 w-full whitespace-normal px-4 py-3 text-sm";

export const TALENT_NETWORK_DEMO_ACTIVITY = {
  hired: 24,
  viewedMembers: 103,
  profileViews: 1248,
} as const;

export const TALENT_NETWORK_FIELD_COLORS: Record<string, string> = {
  engineering: "#FF5AA9",
  data_analytics: "#85C9F7",
  creative_design: "#B79BE9",
  marketing: "#FFA889",
  customer_support: "#8AD3B4",
  product: "#F5D675",
  sales: "#88B9D6",
  finance: "#C5B17C",
  hr_recruitment: "#E4A7C2",
  other: "#D1CEC9",
};
